import wallet from './wallet';
import claim from './claim';

export default {
    ...wallet,
    ...claim,
};
